// extracted by mini-css-extract-plugin
export default {"createCard":"CreateTile_createCard__EVipM","createInner":"CreateTile_createInner__p4oM1"};